(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[506],{

/***/ 59622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _business_hub_footnotes_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35789);
/* harmony import */ var _business_hub_footnotes_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_business_hub_footnotes_module_scss__WEBPACK_IMPORTED_MODULE_1__);


const BusinessHubFootnotes = (props)=>{
    const { content  } = props;
    if (!content) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_business_hub_footnotes_module_scss__WEBPACK_IMPORTED_MODULE_1___default().container),
        dangerouslySetInnerHTML: {
            __html: content || ""
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BusinessHubFootnotes);


/***/ }),

/***/ 78506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ b2b_layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(56779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(42132);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./styles/generic.module.scss
var generic_module = __webpack_require__(64256);
// EXTERNAL MODULE: ./utils/Builder.ts + 1 modules
var Builder = __webpack_require__(20358);
// EXTERNAL MODULE: ./components/business-button/business-button.tsx
var business_button = __webpack_require__(52955);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-footer/b2b-footer-bottom.module.scss
var b2b_footer_bottom_module = __webpack_require__(13226);
var b2b_footer_bottom_module_default = /*#__PURE__*/__webpack_require__.n(b2b_footer_bottom_module);
// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(75102);
// EXTERNAL MODULE: ./components/business-button/business-button.constants.ts
var business_button_constants = __webpack_require__(79892);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-footer/b2b-footer-bottom.tsx






const B2BFooterBottom = (param)=>{
    let { ctaLink , page  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_footer_bottom_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_footer_bottom_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((b2b_footer_bottom_module_default()).title),
                children: "Ready to grow your business?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderContent */.Ku, {
                model: "business-hub",
                content: page,
                children: (variant)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                        autoMargin: false,
                        link: (ref = variant === null || variant === void 0 ? void 0 : variant.signupLink) !== null && ref !== void 0 ? ref : ctaLink,
                        className: (b2b_footer_bottom_module_default()).button,
                        buttonText: "Get started today",
                        target: "_blank",
                        color: business_button_constants/* COLORS.BLACK */.DM.BLACK
                    });
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-footer/b2b-footer-contact-us/b2b-footer-contact-us.module.scss
var b2b_footer_contact_us_module = __webpack_require__(8283);
var b2b_footer_contact_us_module_default = /*#__PURE__*/__webpack_require__.n(b2b_footer_contact_us_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-footer/b2b-footer-contact-us/b2b-footer-contact-us.tsx





const B2BFooterContactUs = (props)=>{
    const { rounded , autoLayout  } = props;
    const [isShowMessage, setIsShowMessage] = (0,react.useState)(false);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const handleOnSuccess = ()=>{
        setIsShowMessage(true);
    };
    (0,react.useEffect)(()=>{
        if (!inView) {
            return;
        }
        const MktoForms2 = window.MktoForms2;
        const loadMarketoForm = ()=>{
            const newScriptElement = document.createElement("script");
            newScriptElement.onload = ()=>{
                triggerMarketoForm();
            };
            newScriptElement.setAttribute("src", "https://www.workwithsquare.com/js/forms2/js/forms2.min.js");
            document.body.appendChild(newScriptElement);
        };
        const triggerMarketoForm = ()=>{
            var ref;
            if (!window.MktoForms2) {
                return;
            }
            (ref = window.MktoForms2) === null || ref === void 0 ? void 0 : ref.loadForm("//www.workwithsquare.com", "424-IAB-218", 11166, function(form) {
                form.onSuccess(function() {
                    handleOnSuccess();
                    return false;
                });
            });
        };
        if (!MktoForms2) {
            loadMarketoForm();
        } else {
            triggerMarketoForm();
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "contact-us",
            className: classnames_default()((b2b_footer_contact_us_module_default()).section, {
                [(b2b_footer_contact_us_module_default()).layout]: autoLayout
            }),
            ref: ref,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((b2b_footer_contact_us_module_default()).background, {
                        [(b2b_footer_contact_us_module_default()).rounded]: rounded
                    }),
                    children: " "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_footer_contact_us_module_default()).title,
                    children: "Contact us."
                }),
                isShowMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_footer_contact_us_module_default()).sectionAfterSubmit,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "Thank you for your interest.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Our team will be in touch with you shortly."
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    id: "mktoForm_11166",
                    className: (b2b_footer_contact_us_module_default()).sectionForm
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(48771);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-footer/b2b-footer-top.module.scss
var b2b_footer_top_module = __webpack_require__(98416);
var b2b_footer_top_module_default = /*#__PURE__*/__webpack_require__.n(b2b_footer_top_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-footer/b2b-footer-top.tsx








const B2BFooterTop = (props)=>{
    const { theme , ctaLink , page  } = props;
    const [endCap, setEndCap] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        setEndCap("https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2Fd855b567b9e24d3596a4289a5f643092");
    }, []);
    const title = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_footer_top_module_default()).title,
            children: [
                "Tap into ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "footer-asterisk"
                }),
                "57M",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (b2b_footer_top_module_default()).plus,
                    children: "+"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                    className: (b2b_footer_top_module_default()).desktopBr
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                    className: (b2b_footer_top_module_default()).mobileBr
                }),
                "incremental monthly\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                    className: (b2b_footer_top_module_default()).desktopBr
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                    className: (b2b_footer_top_module_default()).mobileBr
                }),
                "active customers\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_footer_top_module_default()).subtitle,
                    children: "Let shoppers pay in 4 or monthly, driving incremental sales and growth for your business."
                })
            ]
        });
    }, []);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((b2b_footer_top_module_default()).container, {
            [(b2b_footer_top_module_default())["--light"]]: theme === "light"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_footer_top_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (b2b_footer_top_module_default()).left,
                    children: [
                        title,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (b2b_footer_top_module_default()).description,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "•"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Free sign-up."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "•"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Easy integration."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "•"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Simple, transparent pricing."
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderContent */.Ku, {
                            model: "business-hub",
                            content: page,
                            children: (variant)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                                    link: (ref = variant === null || variant === void 0 ? void 0 : variant.signupLink) !== null && ref !== void 0 ? ref : ctaLink,
                                    className: (b2b_footer_top_module_default()).button,
                                    buttonText: "Get started",
                                    target: "_blank",
                                    color: business_button_constants/* COLORS.BLACK */.DM.BLACK
                                });
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_footer_top_module_default()).right,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_footer_top_module_default()).rightBox,
                        children: endCap ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: endCap,
                            alt: "",
                            style: {
                                objectFit: "cover",
                                objectPosition: "center"
                            },
                            fill: true,
                            loading: "eager",
                            loader: (param)=>{
                                let { src , width , quality  } = param;
                                return "".concat(src, "?width=").concat(width, "&quality=").concat(quality !== null && quality !== void 0 ? quality : 75);
                            },
                            sizes: "(max-width: 638px) 98vw, (max-width: 998px) 43vw, 46vw",
                            className: (b2b_footer_top_module_default()).image
                        }) : null
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-footer/b2b-footer.module.scss
var b2b_footer_module = __webpack_require__(90801);
var b2b_footer_module_default = /*#__PURE__*/__webpack_require__.n(b2b_footer_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-footer/b2b-footer.tsx





const B2BFooter = (param)=>{
    let { theme , footerLink , showContactUsForm , showSayHello =true , showReadyToGrow =true , page  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (b2b_footer_module_default()).container,
        children: [
            showSayHello ? /*#__PURE__*/ (0,jsx_runtime.jsx)(B2BFooterTop, {
                theme: theme,
                ctaLink: footerLink,
                page: page
            }) : null,
            showContactUsForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(B2BFooterContactUs, {
                rounded: !showReadyToGrow
            }) : null,
            showReadyToGrow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(B2BFooterBottom, {
                ctaLink: footerLink,
                page: page
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./components/icons/index.tsx + 91 modules
var icons = __webpack_require__(66714);
// EXTERNAL MODULE: ./helpers/cookieUtils.ts
var cookieUtils = __webpack_require__(65443);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-newsletter/b2b-newsletter.module.scss
var b2b_newsletter_module = __webpack_require__(42770);
var b2b_newsletter_module_default = /*#__PURE__*/__webpack_require__.n(b2b_newsletter_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-newsletter/b2b-newsletter.tsx






const iconArrowRight = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M0.5 8.5H15.5" stroke="white" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>\n<path d="M10.5 3.5L15.5 8.5L10.5 13.5" stroke="white" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>\n</svg>';
const B2BNewsletter = (props)=>{
    const [newsLetterSignUp, setNewsletterSignUp] = (0,react.useState)(false);
    const [isShowMessage, setIsShowMessage] = (0,react.useState)(false);
    const { ref , inView  } = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true
    });
    const handleOnSuccess = ()=>{
        (0,cookieUtils/* setCookie */.d8)("NewsletterSignUp", "true");
        setIsShowMessage(true);
    };
    (0,react.useEffect)(()=>{
        const newsletterSignUpCookie = (0,cookieUtils/* getCookie */.ej)("NewsletterSignUp");
        if (newsletterSignUpCookie && newsletterSignUpCookie !== "") {
            setNewsletterSignUp(true);
        }
    }, [
        newsLetterSignUp
    ]);
    (0,react.useEffect)(()=>{
        if (!inView) {
            return;
        }
        const MktoForms2 = window.MktoForms2;
        const loadMarketoForm = ()=>{
            const newScriptElement = document.createElement("script");
            newScriptElement.onload = ()=>{
                triggerMarketoForm();
            };
            newScriptElement.setAttribute("src", "https://www.workwithsquare.com/js/forms2/js/forms2.min.js");
            document.body.appendChild(newScriptElement);
        };
        const triggerMarketoForm = ()=>{
            var ref;
            if (!window.MktoForms2) {
                return;
            }
            (ref = window.MktoForms2) === null || ref === void 0 ? void 0 : ref.loadForm("//www.workwithsquare.com", "424-IAB-218", 11157, function(form) {
                form.getFormElem().find("button.mktoButton").html('<div class="button-submit">Subscribe Now</div>');
                form.getFormElem().find("input.mktoEmailField").attr("placeholder", "Enter your email here...");
                form.onSuccess(function() {
                    handleOnSuccess();
                    return false;
                });
            });
        };
        if (!MktoForms2) {
            loadMarketoForm();
        } else {
            triggerMarketoForm();
        }
    }, [
        inView
    ]);
    if (newsLetterSignUp) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_newsletter_module_default()).b2bNewsletter,
            ref: ref,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_newsletter_module_default()).b2bNewsletterInfoBackground,
                    children: " "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (b2b_newsletter_module_default()).b2bNewsletterInfo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (b2b_newsletter_module_default()).b2bNewsletterTitle,
                        children: "Get small business advice and insights straight to your inbox."
                    })
                }),
                isShowMessage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (b2b_newsletter_module_default()).b2bNewsletterAfterSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                            type: icons/* IconType.Subscribed */.T.Subscribed
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                "Thanks!",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "You're now subscribed."
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    id: "mktoForm_11157",
                    className: (b2b_newsletter_module_default()).b2bNewsletterForm
                })
            ]
        })
    });
};
/* harmony default export */ var b2b_newsletter = (B2BNewsletter);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(76899);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(77868);
// EXTERNAL MODULE: ./hook/useWindowSize.ts
var useWindowSize = __webpack_require__(77442);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-top-navigation/b2b-top-navigation.module.scss
var b2b_top_navigation_module = __webpack_require__(52300);
var b2b_top_navigation_module_default = /*#__PURE__*/__webpack_require__.n(b2b_top_navigation_module);
// EXTERNAL MODULE: ./contexts/LayoutContext.tsx
var LayoutContext = __webpack_require__(21513);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(75407);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 53 modules
var usePopper = __webpack_require__(31882);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-hub-primary-actions/b2b-menu-item.module.scss
var b2b_menu_item_module = __webpack_require__(92990);
var b2b_menu_item_module_default = /*#__PURE__*/__webpack_require__.n(b2b_menu_item_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-hub-primary-actions/b2b-menu-dropdown.tsx







const B2BMenuDropdown = (props, ref)=>{
    const { items , popperStyles , attributes  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const route = (0,router.useRouter)();
    const activeUrl = (0,react.useMemo)(()=>{
        if (route.isFallback) return "";
        return route.query.slug && Array.isArray(route.query.slug) ? "/".concat(route.query.slug.join("/")) : route.query.slug;
    }, [
        route
    ]);
    const getAnchorTarget = (href)=>{
        if (!href) return "_blank";
        if (href.startsWith("http://") || href.startsWith("https://")) {
            let domain = new URL(href);
            if ( true && domain.origin === window.location.origin) {
                return "_self";
            }
            return "_blank";
        }
        return "_self";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: (b2b_menu_item_module_default()).dropdownContainer,
        style: popperStyles.popper,
        ...(attributes === null || attributes === void 0 ? void 0 : attributes.popper) || {},
        children: items === null || items === void 0 ? void 0 : items.map((item)=>{
            const href = (0,LangHelper/* replaceOrAddLocale */.yM)(item.url || "", locale);
            const target = getAnchorTarget(href);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                className: classnames_default()((b2b_menu_item_module_default()).menuItem, (b2b_menu_item_module_default()).child, {
                    [(b2b_menu_item_module_default()).active]: activeUrl === href
                }),
                target: target,
                "aria-label": item.name,
                children: item.name
            }, item.key);
        })
    });
};
/* harmony default export */ var b2b_menu_dropdown = (/*#__PURE__*/(0,react.forwardRef)(B2BMenuDropdown));

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-hub-primary-actions/b2b-menu-item.tsx









const B2BMenuItem = (props)=>{
    const { name , url , locale: itemLocale , childrenItems  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [referenceElement, setReferenceElement] = (0,react.useState)(null);
    const [popperElement, setPopperElement] = (0,react.useState)(null);
    const route = (0,router.useRouter)();
    const isActive = (0,react.useMemo)(()=>{
        if (route.isFallback) return false;
        const itemUrl = (0,LangHelper/* replaceOrAddLocale */.yM)(url || "", locale);
        const pageSlug = route.query.slug && Array.isArray(route.query.slug) ? "/".concat(route.query.slug.join("/")) : route.query.slug;
        return pageSlug === itemUrl;
    }, [
        route
    ]);
    const { styles: popperStyles , attributes  } = (0,usePopper/* usePopper */.D)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        14
                    ]
                }
            },
            {
                name: "eventListeners",
                enabled: false
            }
        ],
        placement: "bottom-start",
        strategy: "absolute"
    });
    if ((itemLocale === null || itemLocale === void 0 ? void 0 : itemLocale.length) && !itemLocale.includes(locale)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: setReferenceElement,
        className: (b2b_menu_item_module_default()).container,
        children: [
            url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: (0,LangHelper/* replaceOrAddLocale */.yM)(url || "", locale),
                className: classnames_default()((b2b_menu_item_module_default()).menuItem, {
                    [(b2b_menu_item_module_default()).active]: isActive
                }),
                "aria-label": name,
                children: name
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (b2b_menu_item_module_default()).menuItem,
                children: name
            }),
            childrenItems ? /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_menu_dropdown, {
                ref: setPopperElement,
                items: childrenItems.filter((child)=>{
                    if (!child.locale) return true;
                    return child.locale.includes(locale);
                }),
                popperStyles: popperStyles,
                attributes: attributes
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-hub-primary-actions/b2b-top-navigation-menu-item.module.scss
var b2b_top_navigation_menu_item_module = __webpack_require__(17551);
var b2b_top_navigation_menu_item_module_default = /*#__PURE__*/__webpack_require__.n(b2b_top_navigation_menu_item_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-hub-primary-actions/b2b-top-navigation-menu-item.tsx




const B2BTopNavigationMenuItem = (props)=>{
    const { businessHubMenuData =[]  } = (0,LayoutContext/* useBusinessLayout */.Vp)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (b2b_top_navigation_menu_item_module_default()).container,
        children: businessHubMenuData.map((param)=>/*#__PURE__*/ {
            let { key , ...data } = param;
            return (0,jsx_runtime.jsx)(B2BMenuItem, {
                ...data
            }, key);
        })
    });
};

// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-hub-primary-actions/business-hub-primary-actions.module.scss
var business_hub_primary_actions_module = __webpack_require__(19151);
var business_hub_primary_actions_module_default = /*#__PURE__*/__webpack_require__.n(business_hub_primary_actions_module);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-sign-up-button/business-sign-up-button.module.scss
var business_sign_up_button_module = __webpack_require__(73388);
var business_sign_up_button_module_default = /*#__PURE__*/__webpack_require__.n(business_sign_up_button_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-sign-up-button/business-sign-up-button.tsx





const BusinessSignUpButton = (props)=>{
    const { page , signupLink , isMobile  } = props;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderContent */.Ku, {
        model: "business-hub",
        content: page,
        children: (variant)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                link: (ref = variant === null || variant === void 0 ? void 0 : variant.signupLink) !== null && ref !== void 0 ? ref : signupLink,
                target: "_blank",
                className: (business_sign_up_button_module_default()).container,
                buttonText: isMobile ? "Sign-up" : "Business sign-up",
                autoMargin: false,
                color: business_button_constants/* COLORS.BLACK */.DM.BLACK
            });
        }
    });
};

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-hub-primary-actions/business-hub-primary-actions.tsx





const BusinessHubPrimaryActions = (props)=>{
    const { page , signupLink , isMobile , isMobileMenuActive  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((business_hub_primary_actions_module_default()).container),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_hub_primary_actions_module_default()).menuItems, {
                    [(business_hub_primary_actions_module_default()).active]: isMobileMenuActive
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(B2BTopNavigationMenuItem, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessSignUpButton, {
                page: page,
                isMobile: isMobile,
                signupLink: signupLink
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/auto-complete-form/business-header-autocomplete-list.tsx
var business_header_autocomplete_list = __webpack_require__(82625);
// EXTERNAL MODULE: ./hook/useOutsideClick.ts
var useOutsideClick = __webpack_require__(85704);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-access-primary-actions/business-access-primary-actions.module.scss
var business_access_primary_actions_module = __webpack_require__(59707);
var business_access_primary_actions_module_default = /*#__PURE__*/__webpack_require__.n(business_access_primary_actions_module);
// EXTERNAL MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-access-primary-actions/dropdown-explore/dropdown-explore.module.scss
var dropdown_explore_module = __webpack_require__(89713);
var dropdown_explore_module_default = /*#__PURE__*/__webpack_require__.n(dropdown_explore_module);
;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-access-primary-actions/dropdown-explore/dropdown-explore.tsx








const dummyResources = [
    {
        name: "Marketing Resources",
        description: "",
        resourceUrl: "/business/resources/marketing",
        locale: LangHelper/* ALL_LOCALES */.En
    },
    {
        name: "Training",
        description: "",
        resourceUrl: "/business/resources/training",
        locale: LangHelper/* ALL_LOCALES.filter */.En.filter((location)=>location !== LangHelper/* Locale.GreatBritain */.go.GreatBritain && location !== LangHelper/* Locale.USA */.go.USA)
    },
    {
        name: "Product Updates",
        description: "",
        resourceUrl: "/business/resources/product-updates",
        locale: LangHelper/* ALL_LOCALES.filter */.En.filter((locale)=>locale !== LangHelper/* Locale.USA */.go.USA)
    },
    {
        name: "Help Center",
        description: "",
        resourceUrl: "/business/resources/contact-us",
        locale: [
            LangHelper/* Locale.USA */.go.USA
        ]
    },
    {
        name: "Customer Service",
        description: "",
        resourceUrl: "/business/resources/customer-service",
        locale: LangHelper/* ALL_LOCALES.filter */.En.filter((location)=>[
                LangHelper/* Locale.USA */.go.USA,
                LangHelper/* Locale.GreatBritain */.go.GreatBritain
            ].includes(location))
    }
];
const DropdownExplore = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [sortedGuides, setGuides] = (0,react.useState)([]);
    const { isToggle , isMobile , categories , guides  } = props;
    (0,react.useEffect)(()=>{
        // You're welcome
        const dummyGuides = [
            {
                name: "Meet Gen Z & Millenials",
                guideUrl: "/business/access/meet-gen-z---millennials"
            },
            {
                name: "Growing with ".concat(locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain ? "Clearpay" : "Afterpay"),
                guideUrl: "/business/access/growing-with-".concat(locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain ? "clearpay" : "afterpay")
            },
            {
                name: "Social Media Tips",
                guideUrl: "/business/access/social-media-tips"
            },
            {
                name: "Content Marketing ",
                guideUrl: "/business/access/content-marketing"
            },
            {
                name: "SEO Tips",
                guideUrl: "/business/access/seo-tips"
            }
        ];
        setGuides(dummyGuides);
        return;
    }, [
        guides
    ]);
    if (!categories) {
        return null;
    }
    const accessHref = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale, "/business/access"), locale);
    const guidePageHref = (0,LangHelper/* localifyLink */.Bj)("/".concat(locale, "/business/access/guides"), locale);
    //TODO make these business resource pages come from a generalized location.
    const renderCategories = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: (dropdown_explore_module_default()).latestArticlesListWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (dropdown_explore_module_default()).articleTypeTitle,
                    href: accessHref,
                    children: "Topics"
                }),
                categories.map((category)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(category.categoryUrl), locale),
                            className: (dropdown_explore_module_default()).articleTypeName,
                            children: category.name
                        })
                    }, category.name);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                    className: (dropdown_explore_module_default()).viewAll,
                    buttonText: "View all articles",
                    icon: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium,
                    link: accessHref,
                    target: "_self",
                    color: business_button_constants/* COLORS.BLACK */.DM.BLACK,
                    autoMargin: false,
                    size: "small"
                })
            ]
        });
    };
    const renderGuides = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: (dropdown_explore_module_default()).latestArticlesListWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (dropdown_explore_module_default()).articleTypeTitle,
                    href: guidePageHref,
                    children: "Guides"
                }),
                sortedGuides.slice(0, 5).map((series)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(series.guideUrl), locale),
                            className: (dropdown_explore_module_default()).articleTypeName,
                            children: series.name
                        })
                    }, series.name);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(business_button/* default */.Z, {
                    className: (dropdown_explore_module_default()).viewAll,
                    buttonText: "View all guides",
                    icon: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium,
                    link: guidePageHref,
                    target: "_self",
                    color: business_button_constants/* COLORS.BLACK */.DM.BLACK,
                    autoMargin: false,
                    size: "small"
                })
            ]
        });
    };
    const renderMoreResources = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (dropdown_explore_module_default()).moreResourceWrapper,
            children: dummyResources.map((resource)=>{
                if (!resource.locale.includes(locale)) return null;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (dropdown_explore_module_default()).moreResourceContainer,
                    href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale).concat(resource.resourceUrl), locale),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (dropdown_explore_module_default()).moreResourceName,
                                    children: resource.name
                                }),
                                resource.description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (dropdown_explore_module_default()).moreResourceDescription,
                                    children: resource.description
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (dropdown_explore_module_default()).moreResourceViewMoreIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.ArrowRightMedium */.T.ArrowRightMedium
                            })
                        })
                    ]
                }, resource.name);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((dropdown_explore_module_default()).dropdownExplore, {
            [(dropdown_explore_module_default()).toggleExploreOn]: isToggle,
            [(dropdown_explore_module_default()).mobile]: isMobile
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (dropdown_explore_module_default()).dropdownContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (dropdown_explore_module_default()).latestArticles,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale, "/business/access"), locale),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (dropdown_explore_module_default()).dropdownTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        type: icons/* IconType.ReadBook */.T.ReadBook
                                    }),
                                    locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain ? "Clearpay Access" : "Afterpay Access"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (dropdown_explore_module_default()).latestArticlesContainer,
                            children: [
                                renderCategories(),
                                renderGuides()
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (dropdown_explore_module_default()).moreResource,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (0,LangHelper/* localifyLink */.Bj)("/".concat(locale, "/business/resources/"), locale),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (dropdown_explore_module_default()).dropdownTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                        type: icons/* IconType.Resource */.T.Resource
                                    }),
                                    "More Resources"
                                ]
                            })
                        }),
                        renderMoreResources()
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var dropdown_explore = (DropdownExplore);

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-top-navigation/business-access-primary-actions/business-access-primary-actions.tsx











const BusinessAccessPrimaryActions = (props)=>{
    const { isMobile =false , isMobileMenuActive =false , onToggleMenu  } = props;
    const { categories: categoriesProps  } = (0,LayoutContext/* useBusinessLayout */.Vp)();
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [isShowDrawerContent, setShowMenu] = (0,react.useState)(false);
    const [isShowExplore, setShowExplore] = (0,react.useState)(false);
    const [isShowFormSearch, setShowFormSearch] = (0,react.useState)(false);
    const [categories, setMappedCategories] = (0,react.useState)([]);
    const navRef = (0,react.useRef)(null);
    const showDrawerContent = (0,react.useMemo)(()=>{
        if (isMobile) {
            return isMobileMenuActive;
        }
        return isShowDrawerContent;
    }, [
        isMobile,
        isMobileMenuActive
    ]);
    (0,react.useEffect)(()=>{
        getCategories(categoriesProps);
    }, [
        categoriesProps
    ]);
    (0,react.useEffect)(()=>{
        const body = document.body;
        if (!body) {
            return;
        }
        if (showDrawerContent) {
            body.classList.add("lock-scroll");
        } else {
            body.classList.remove("lock-scroll");
        }
    }, [
        showDrawerContent
    ]);
    const categoryOrder = [
        "News",
        "Success Stories",
        "Marketing",
        "Operations",
        "Finance"
    ];
    const getCategories = (categories)=>{
        if (categories && categories.length > 0) {
            categories.sort((a, b)=>{
                const indexOfA = categoryOrder.indexOf(a.name);
                const indexOfB = categoryOrder.indexOf(b.name);
                if (indexOfA !== -1 && indexOfA !== indexOfB) {
                    return indexOfA - indexOfB;
                }
                return a.name.localeCompare(b.name);
            });
            const indx = categories.map((c)=>c.name).indexOf(categoryOrder[0]);
            const priorityCategory = categories.slice(indx);
            const normalCategory = categories.slice(0, indx);
            setMappedCategories([
                ...priorityCategory,
                ...normalCategory
            ]);
        }
    };
    const getGuides = ()=>{
        var _categoryUrl;
        return categories.filter((category)=>{
            if (category.isSeries) {
                return category;
            }
        }).map((category)=>({
                name: category.name,
                guideUrl: (_categoryUrl = category.categoryUrl) !== null && _categoryUrl !== void 0 ? _categoryUrl : ""
            }));
    };
    const sortCategoriesForDropdown = (categories)=>{
        if (categories && categories.length > 0) {
            let categoriesMap = [];
            for(let i = 0; i < categoryOrder.length; i++){
                const categoryFilter = categories.find((category)=>category.name === categoryOrder[i]);
                categoriesMap.push(categoryFilter);
            }
            return categoriesMap;
        }
    };
    (0,useOutsideClick/* default */.Z)(navRef, ()=>{
        setShowExplore(false);
    });
    const toggleShowHideExplore = ()=>{
        if (!isShowExplore) {
            setShowFormSearch(false);
        }
        setShowExplore(!isShowExplore);
    };
    const handleToggleFormSearch = ()=>{
        setShowFormSearch(!isShowFormSearch);
    };
    const signupButton = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (business_access_primary_actions_module_default()).cta,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessSignUpButton, {
                signupLink: (LangHelper/* LOCALE_LINKS */.kV[locale] || LangHelper/* LOCALE_LINKS */.kV[LangHelper/* DEFAULT_LANG */.Hj]).signup,
                isMobile: isMobile
            })
        });
    const renderDropDownExplore = (0,react.useCallback)(()=>{
        if (isMobile) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((business_access_primary_actions_module_default()).buttonExplore, {
                        [(business_access_primary_actions_module_default()).buttonActive]: isShowExplore
                    }),
                    onClick: ()=>toggleShowHideExplore(),
                    children: [
                        "Explore",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_access_primary_actions_module_default()).iconDown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                type: icons/* IconType.Down */.T.Down
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_explore, {
                    isToggle: isShowExplore,
                    categories: sortCategoriesForDropdown(categories),
                    guides: getGuides(),
                    isMobile: isMobile
                })
            ]
        });
    }, [
        isMobile,
        isShowExplore
    ]);
    const renderButtonToggleDrawer = ()=>{
        if (isMobile) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (business_access_primary_actions_module_default()).menuRight,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(business_header_autocomplete_list/* default */.Z, {
                    isShown: isShowFormSearch,
                    onClickButtonSearch: ()=>handleToggleFormSearch(),
                    onFocus: ()=>setShowFormSearch(true),
                    onSearch: ()=>{
                        setShowExplore(false);
                    },
                    onClose: ()=>setShowFormSearch(false)
                }),
                signupButton()
            ]
        });
    };
    const renderDrawerContent = ()=>{
        if (!showDrawerContent) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((business_access_primary_actions_module_default()).drawerMenu, {
                [(business_access_primary_actions_module_default()).mobile]: isMobile
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (business_access_primary_actions_module_default()).drawerMenuButton,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(business_header_autocomplete_list/* default */.Z, {
                            isShown: isShowFormSearch,
                            onClickButtonSearch: ()=>setShowFormSearch(true),
                            onFocus: ()=>setShowFormSearch(true),
                            onClose: ()=>setShowFormSearch(false)
                        }),
                        !isMobile && !isShowFormSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (business_access_primary_actions_module_default()).accountGroup,
                            children: signupButton()
                        })
                    ]
                }),
                !isShowFormSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_explore, {
                    isToggle: true,
                    categories: sortCategoriesForDropdown(categories),
                    isMobile: isMobile
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((business_access_primary_actions_module_default()).background, {
                    [(business_access_primary_actions_module_default()).show]: showDrawerContent
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((business_access_primary_actions_module_default()).container, {
                    [(business_access_primary_actions_module_default()).mobile]: isMobile
                }),
                ref: navRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((business_access_primary_actions_module_default()).articleHeaderContainer, {
                            [(business_access_primary_actions_module_default()).toggleMenu]: showDrawerContent
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (business_access_primary_actions_module_default()).logoWrapper,
                                children: renderDropDownExplore()
                            }),
                            renderButtonToggleDrawer()
                        ]
                    }),
                    renderDrawerContent(),
                    isMobile && signupButton()
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/afterpay-goes-green/b2b-top-navigation/b2b-top-navigation.tsx











const B2BTopNavigation = (props)=>{
    const { signupLink , page , model  } = props;
    const [isMobileMenuActive, setIsMobileMenuActive] = (0,react.useState)(false);
    const [needCloseMobileMenu, setNeedCloseMobileMenu] = (0,react.useState)(false);
    const [isMobile, setIsMobile] = (0,react.useState)(false);
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    const [scrollY, setScrollY] = (0,react.useState)(0);
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    (0,react.useEffect)(()=>{
        if (width < 1200) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [
        width
    ]);
    (0,react.useEffect)(()=>{
        if (isMobile) {
            if (needCloseMobileMenu) {
                setNeedCloseMobileMenu(false);
                setIsMobileMenuActive(false);
            }
        } else {
            setNeedCloseMobileMenu(true);
            if (isMobileMenuActive) {
                setIsMobileMenuActive(false);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isMobile
    ]);
    (0,react.useEffect)(()=>{
        const body = document.body;
        if (!body) {
            return;
        }
        if (isMobileMenuActive) {
            body.classList.add("lock-scroll");
        } else {
            body.classList.remove("lock-scroll");
        }
    }, [
        isMobileMenuActive
    ]);
    (0,react.useEffect)(()=>{
        document.addEventListener("scroll", onScroll);
        onScroll();
        return ()=>{
            document.removeEventListener("scroll", onScroll);
        };
    }, []);
    const onScroll = (0,react.useCallback)(()=>{
        setScrollY(window.scrollY);
    }, []);
    const handleClickToggleMenu = ()=>{
        setIsMobileMenuActive((oldState)=>!oldState);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (b2b_top_navigation_module_default()).container,
        style: {
            "--bh-scroll-y": "".concat(scrollY, "px")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (b2b_top_navigation_module_default()).box,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: (0,LangHelper/* replaceOrAddLocale */.yM)("/business", locale),
                    className: (b2b_top_navigation_module_default()).logo,
                    "aria-label": "Home",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        type: icons/* IconType.AfterpayLogo */.T.AfterpayLogo
                    })
                }),
                model === Builder/* BuilderModel.BUSINESS_HUB */.v1.BUSINESS_HUB ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessHubPrimaryActions, {
                    page: page,
                    signupLink: signupLink,
                    isMobile: isMobile,
                    isMobileMenuActive: isMobileMenuActive
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessAccessPrimaryActions, {
                    isMobile: isMobile,
                    isMobileMenuActive: isMobileMenuActive,
                    onToggleMenu: handleClickToggleMenu
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((b2b_top_navigation_module_default()).hamburger, {
                        [(b2b_top_navigation_module_default()).active]: isMobileMenuActive
                    }),
                    onClick: ()=>handleClickToggleMenu(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (b2b_top_navigation_module_default()).iconMenu,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/business-footer/business-footer.tsx + 1 modules
var business_footer = __webpack_require__(41519);
// EXTERNAL MODULE: ./components/business-hub-footnotes/business-hub-footnotes.tsx
var business_hub_footnotes = __webpack_require__(59622);
;// CONCATENATED MODULE: ./components/layouts/b2b-layout.tsx













const B2BLayout = (props)=>{
    const { page , model , children  } = props;
    const { footerItems , theme , footnotes , hideFooter , hideNav , showContactUsForm , showSayHello , showReadyToGrow  } = (page === null || page === void 0 ? void 0 : page.data) || {};
    const localeName = (0,react.useMemo)(()=>{
        return "United States";
    }, []);
    const copyright = (0,react.useMemo)(()=>{
        return "\xa9 2025 Afterpay";
    }, []);
    const onboardingLink = (0,react.useMemo)(()=>{
        return "https://hub.us.afterpay.com/signup";
    }, []);
    const LocaleIcon = localeName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: generic_module.locale,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "19",
                height: "20",
                viewBox: "0 0 19 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.2222 1.02319V2.78424C13.7256 3.35398 15.7715 5.14095 16.7038 7.48034C15.055 6.63436 12.7156 6.15092 10.3589 6.04733V1.71383C10.3589 1.71383 10.3589 1.71382 10.3589 1.70519V0.89379C10.0741 0.867893 9.78918 0.850586 9.49568 0.850586C4.25579 0.850586 0 5.10638 0 10.3463C0 14.9905 3.35802 18.8579 7.76919 19.678V17.9169C5.26579 17.3472 3.21989 15.5602 2.28759 13.2208C3.93639 14.0668 6.28442 14.5589 8.64108 14.6538V18.0723V19.8074C8.92595 19.8333 9.21082 19.8506 9.50432 19.8506C14.7442 19.8506 19 15.5948 19 10.3549C19 5.71066 15.642 1.84327 11.2308 1.02319H11.2222ZM17.2649 10.3549C17.2649 11.3476 14.6061 12.7547 10.3589 12.9274V7.78246C14.5974 7.95511 17.2649 9.36218 17.2649 10.3549ZM8.63244 2.63756V6.05597C6.27578 6.15093 3.92777 6.64301 2.27898 7.48898C3.3235 4.87336 5.74057 2.95696 8.63244 2.63756ZM1.72649 10.3549C1.72649 9.36218 4.39391 7.95511 8.63244 7.78246V12.9274C4.38528 12.7547 1.72649 11.3476 1.72649 10.3549ZM10.3589 18.0723V14.6538C12.7156 14.5589 15.055 14.0668 16.7038 13.2208C15.6592 15.8278 13.2508 17.7442 10.3589 18.0723Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: localeName
                })
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(generic_module["b2b-layout"], "b2b-layout"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "icon",
                    href: "/us-favicon.svg"
                })
            }),
            hideNav ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(B2BTopNavigation, {
                page: page,
                model: model,
                signupLink: onboardingLink
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(generic_module.content, generic_module["--no-top-padding"]),
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: generic_module.footer,
                children: [
                    model === Builder/* BuilderModel.BUSINESS_HUB */.v1.BUSINESS_HUB ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            hideFooter ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(B2BFooter, {
                                theme: theme,
                                showContactUsForm: showContactUsForm,
                                showSayHello: showSayHello,
                                showReadyToGrow: showReadyToGrow,
                                footerLink: onboardingLink,
                                page: page
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(business_hub_footnotes/* default */.Z, {
                                content: footnotes
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(b2b_newsletter, {}),
                    LocaleIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(generic_module["disclaimers-box"], generic_module.mobile),
                        children: LocaleIcon
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: localeName ? generic_module["footer-nav"] : "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(business_footer/* default */.Z, {
                            theme: "white",
                            hideLogo: true,
                            footerData: footerItems,
                            isB2bAnz: false
                        })
                    }),
                    localeName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: generic_module["disclaimers-box"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: generic_module.disclaimers,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: generic_module.desktop,
                                        children: LocaleIcon
                                    }),
                                    copyright ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: generic_module.copyright,
                                        children: copyright
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: generic_module.logo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                                    type: business_button_constants/* ICONS.AfterpayLogo */.UZ.AfterpayLogo
                                })
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var b2b_layout = (B2BLayout);


/***/ }),

/***/ 84618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ models_ArticleModel; }
});

// EXTERNAL MODULE: ./helpers/BuilderHelper.ts
var BuilderHelper = __webpack_require__(31198);
// EXTERNAL MODULE: ./models/BaseModel.ts
var BaseModel = __webpack_require__(23385);
;// CONCATENATED MODULE: ./models/CategoryModel.ts


class CategoryModel extends BaseModel/* default */.Z {
    constructor(){
        super({
            modelName: "category"
        });
        this.getSlug = (categoryName)=>{
            return categoryName.trim().toLowerCase().replace(/[^A-z]/g, "-").trimEnd();
        };
        this.getFromName = async (name)=>{
            const slug = this.getSlug(name);
            const allPossibleCategories = (await this.findAll({
                filters: {
                    limit: 100
                }
            })).map(this.fromBuilderContent);
            for (const category of allPossibleCategories){
                if ("".concat(BuilderHelper/* CATEGORY_ROOT */.X6).concat(slug) === category.categoryUrl) {
                    // TODO refactor check to come from a generic place
                    return category;
                }
            }
            return null;
        };
        this.fromBuilderContent = (object)=>{
            if (!object) {
                return {
                    id: "",
                    name: "",
                    longName: null,
                    description: "",
                    categoryUrl: "",
                    isSeries: false,
                    image: "",
                    lastUpdated: "",
                    exclusiveForLocales: []
                };
            }
            let name;
            let category = object;
            if (object.data === undefined) {
                var _name;
                name = (_name = object.name) !== null && _name !== void 0 ? _name : "";
            } else {
                category = object.data;
                var _name1;
                name = (_name1 = object.name) !== null && _name1 !== void 0 ? _name1 : object.data.name;
            }
            const categorySlug = this.getSlug(name);
            var _longName, _exclusiveForLocales;
            // TODO generalize this parser here
            return {
                id: object.id,
                name,
                longName: (_longName = category.longName) !== null && _longName !== void 0 ? _longName : null,
                categoryUrl: (BuilderHelper/* CATEGORY_ROOT */.X6 + categorySlug).replace(/\/{2,}/g, "/"),
                isSeries: !!category.isSeries || false,
                categorySlug,
                description: category.description || "",
                image: category.image || "",
                lastUpdated: object.lastUpdated || "",
                exclusiveForLocales: (_exclusiveForLocales = category.exclusiveForLocales) !== null && _exclusiveForLocales !== void 0 ? _exclusiveForLocales : []
            };
        };
    }
}
/* harmony default export */ var models_CategoryModel = (new CategoryModel());

;// CONCATENATED MODULE: ./models/ArticleModel.ts



class ArticleModel extends BaseModel/* default */.Z {
    constructor(){
        super({
            modelName: "article"
        });
        this.fromBuilderContent = (object)=>{
            var ref, ref1, ref2, ref3;
            if (!object) return object;
            const oData = object.data;
            const categories = (ref = oData.categories) === null || ref === void 0 ? void 0 : ref.map((category)=>models_CategoryModel.fromBuilderContent(category.category.value));
            const author = oData === null || oData === void 0 ? void 0 : (ref1 = oData.author) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.data;
            var ref4;
            const articleSlug = (ref4 = (ref3 = oData.url) === null || ref3 === void 0 ? void 0 : ref3.replace("/builder/", "")) !== null && ref4 !== void 0 ? ref4 : "";
            const articleUrl = categories && categories.length ? "".concat(categories[0].categoryUrl, "/").concat(articleSlug).replace(/\/{2,}/, "/") : null;
            var _id, _title, _description, _contributors, _leadImage, _leadPortraitImage, _imageMobile, _position, _priority, _seoTitle, ref5, _seoDescription, ref6, _leadVideo, _lastUpdated;
            return {
                id: (_id = object.id) !== null && _id !== void 0 ? _id : null,
                title: (_title = oData.title) !== null && _title !== void 0 ? _title : "",
                description: (_description = oData.description) !== null && _description !== void 0 ? _description : "",
                categories: categories !== null && categories !== void 0 ? categories : null,
                author: author !== null && author !== void 0 ? author : null,
                contributors: (_contributors = oData.contributors) !== null && _contributors !== void 0 ? _contributors : [],
                leadImage: (_leadImage = oData.leadImage) !== null && _leadImage !== void 0 ? _leadImage : null,
                leadPortraitImage: (_leadPortraitImage = oData.leadPortraitImage) !== null && _leadPortraitImage !== void 0 ? _leadPortraitImage : null,
                imageMobile: (_imageMobile = oData.imageMobile) !== null && _imageMobile !== void 0 ? _imageMobile : null,
                position: (_position = oData.position) !== null && _position !== void 0 ? _position : null,
                url: articleUrl !== null && articleUrl !== void 0 ? articleUrl : "",
                articleUrl: articleUrl !== null && articleUrl !== void 0 ? articleUrl : "",
                articleSlug,
                priority: (_priority = oData.priority) !== null && _priority !== void 0 ? _priority : 0,
                builderModel: object !== null && object !== void 0 ? object : null,
                seoTitle: (ref5 = (_seoTitle = oData.seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : oData.title) !== null && ref5 !== void 0 ? ref5 : "",
                seoDescription: (ref6 = (_seoDescription = oData.seoDescription) !== null && _seoDescription !== void 0 ? _seoDescription : oData.description) !== null && ref6 !== void 0 ? ref6 : "",
                leadVideo: (_leadVideo = oData.leadVideo) !== null && _leadVideo !== void 0 ? _leadVideo : null,
                lastUpdated: (_lastUpdated = object.lastUpdated) !== null && _lastUpdated !== void 0 ? _lastUpdated : null
            };
        };
        this.getArticle = async (path, locale, includeUnpublished)=>{
            const urlPath = "/builder/" + path;
            return this.builder.get(this.modelName, {
                options: {
                    locale,
                    includeUnpublished
                },
                userAttributes: {
                    urlPath,
                    locale
                }
            }).toPromise();
        };
        this.getRelatedArticles = async (article, locale)=>{
            if (!article) {
                return [];
            }
            const categoryIds = article.categories ? [
                ...article.categories
            ].map((item)=>{
                return item.id;
            }) : [];
            const config = {
                options: {
                    noTargeting: true
                },
                query: {
                    id: {
                        $nin: BuilderHelper/* excludedArticleIds.concat */.oI.concat([
                            article.builderModel.id
                        ])
                    },
                    "data.categories": {
                        $elemMatch: {
                            "category.id": {
                                $in: [
                                    categoryIds[0]
                                ]
                            }
                        }
                    }
                },
                limit: 3
            };
            if (locale) {
                config.query.query = {
                    $elemMatch: {
                        property: {
                            $eq: "locale"
                        },
                        value: locale
                    }
                };
            }
            const relatedPages = await this.builder.getAll(this.modelName, config);
            const relatedArticles = relatedPages.map((page)=>{
                return this.fromBuilderContent(page);
            });
            return relatedArticles;
        };
        this.getByCategories = (param)=>{
            let { locale , limit , offset , ids , fields  } = param;
            return this.findAll({
                filters: {
                    locale,
                    limit,
                    offset,
                    extra: {
                        id: {
                            $nin: BuilderHelper/* excludedArticleIds */.oI
                        },
                        "data.categories": {
                            $elemMatch: {
                                "category.id": {
                                    $in: ids
                                }
                            }
                        }
                    }
                },
                fields
            });
        };
    }
}
/* harmony default export */ var models_ArticleModel = (new ArticleModel());


/***/ }),

/***/ 48842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _BaseModel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23385);

class BusinessHubModel extends _BaseModel__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
    constructor(){
        super({
            modelName: "business-hub"
        });
        this.getAll = async (param)=>{
            let { includeUnpublished =false , includeDraft =false , fields , limit , offset , locale  } = param;
            const draft = includeDraft !== null && includeDraft !== void 0 ? includeDraft : "draft";
            let paging = {};
            if (Number.isInteger(limit) && Number.isInteger(offset)) {
                paging = {
                    limit,
                    offset
                };
            }
            let query = {
                published: {
                    $ni: [
                        "archived",
                        draft
                    ]
                },
                userAttributes: {}
            };
            if (locale) {
                query.userAttributes.locale = locale;
            }
            const pages = await this.builder.getAll(this.modelName, {
                options: {
                    noTargeting: true,
                    includeUnpublished,
                    locale
                },
                query,
                fields,
                omit: "data.state",
                ...paging
            });
            return pages;
        };
        this.getPage = async (url, locale)=>{
            return this.builder.get(this.modelName, {
                options: {
                    locale
                },
                userAttributes: {
                    urlPath: url,
                    locale
                }
            }).toPromise();
        };
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (new BusinessHubModel());


/***/ }),

/***/ 20358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v1": function() { return /* binding */ BuilderModel; },
  "xX": function() { return /* binding */ getBuilderPreviewPage; }
});

// UNUSED EXPORTS: createArticleStaticPaths, createArticleStaticProps, createStaticPaths, createStaticProps

// EXTERNAL MODULE: ./builder/index.ts + 318 modules
var builder = __webpack_require__(21776);
// EXTERNAL MODULE: ./helpers/cookieUtils.ts
var cookieUtils = __webpack_require__(65443);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(77868);
// EXTERNAL MODULE: ./models/ArticleModel.ts + 1 modules
var models_ArticleModel = __webpack_require__(84618);
// EXTERNAL MODULE: ./models/BusinessHub.ts
var BusinessHub = __webpack_require__(48842);
// EXTERNAL MODULE: ./models/BaseModel.ts
var BaseModel = __webpack_require__(23385);
;// CONCATENATED MODULE: ./models/Page.ts

class Page_PageModel extends BaseModel/* default */.Z {
    constructor(){
        super({
            modelName: "page"
        });
        this.getAll = async (param)=>{
            let { includeUnpublished =false , includeDraft =false , fields , limit , offset , locale  } = param;
            const draft = includeDraft !== null && includeDraft !== void 0 ? includeDraft : "draft";
            let paging = {};
            if (Number.isInteger(limit) && Number.isInteger(offset)) {
                paging = {
                    limit,
                    offset
                };
            }
            let query = {
                published: {
                    $ni: [
                        "archived",
                        draft
                    ]
                },
                userAttributes: {}
            };
            if (locale) {
                query.userAttributes.locale = locale;
            }
            const pages = await this.builder.getAll(this.modelName, {
                options: {
                    noTargeting: true,
                    includeUnpublished,
                    locale
                },
                query,
                fields,
                omit: "data.state",
                ...paging
            });
            return pages;
        };
        this.getPage = async (url, locale)=>{
            return this.builder.get(this.modelName, {
                options: {
                    locale
                },
                userAttributes: {
                    urlPath: url,
                    locale
                }
            }).toPromise();
        };
    }
}
/* harmony default export */ var Page = (new Page_PageModel());

;// CONCATENATED MODULE: ./utils/Builder.ts






var BuilderModel;
(function(BuilderModel) {
    BuilderModel["PAGE"] = "page";
    BuilderModel["BUSINESS_HUB"] = "business-hub";
    BuilderModel["ARTICLE"] = "article";
})(BuilderModel || (BuilderModel = {}));
const FETCH_ALL_LIMIT = 100;
const getPages = async function(includeUnpublished) {
    let offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, locale = arguments.length > 2 ? arguments[2] : void 0;
    let currentPages = await PageModel.getAll({
        includeUnpublished: includeUnpublished !== null && includeUnpublished !== void 0 ? includeUnpublished : false,
        fields: "query,data.url",
        limit: FETCH_ALL_LIMIT,
        locale
    });
    if (currentPages.length == FETCH_ALL_LIMIT) {
        currentPages = [
            ...currentPages,
            ...await getPages(includeUnpublished, offset + FETCH_ALL_LIMIT, locale)
        ];
    }
    return currentPages;
};
const getBusinessHubPages = async function(includeUnpublished) {
    let offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, locale = arguments.length > 2 ? arguments[2] : void 0;
    let currentPages = await BusinessHubModel.getAll({
        includeUnpublished: includeUnpublished !== null && includeUnpublished !== void 0 ? includeUnpublished : false,
        fields: "query,data.url",
        limit: FETCH_ALL_LIMIT,
        locale
    });
    if (currentPages.length == FETCH_ALL_LIMIT) {
        currentPages = [
            ...currentPages,
            ...await getBusinessHubPages(includeUnpublished, offset + FETCH_ALL_LIMIT, locale)
        ];
    }
    return currentPages;
};
const getArticles = async function(includeUnpublished) {
    let offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, locale = arguments.length > 2 ? arguments[2] : void 0;
    let currentPages = await ArticleModel.findAll({
        includeUnpublished: includeUnpublished !== null && includeUnpublished !== void 0 ? includeUnpublished : false,
        fields: "query,data.url,data.categories",
        filters: {
            limit: FETCH_ALL_LIMIT,
            offset,
            locale
        }
    });
    if (currentPages.length == FETCH_ALL_LIMIT) {
        currentPages = [
            ...currentPages,
            ...await getArticles(includeUnpublished, offset + FETCH_ALL_LIMIT, locale)
        ];
    }
    return currentPages;
};
async function getPageStaticPaths(includeUnpublished, locale) {
    const pages = await getPages(includeUnpublished, 0, locale);
    const businessHubPages = await getBusinessHubPages(includeUnpublished, 0, locale);
    const allPaths = [];
    [
        ...pages,
        ...businessHubPages
    ].forEach((page)=>{
        // if (!EXCLUDE_PAGES.includes(page.data?.url)) {
        for (const queryParam of page.query){
            // Query is definitely a parameter. Seems like the types aren't updated.
            if (queryParam.property === "locale") {
                for (const pageLocale of queryParam.value){
                    var ref;
                    allPaths.push(localifyLink("/".concat(pageLocale).concat(page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.url), pageLocale));
                }
            }
        }
    // }
    });
    return {
        paths: allPaths,
        fallback: true
    };
}
async function getArticleStaticPaths(includeUnpublished, locale) {
    const articles = await getArticles(includeUnpublished, 0, locale);
    const pathArray = [];
    articles.map((article)=>{
        const page = ArticleModel.fromBuilderContent(article);
        const queryFilters = article.query;
        // Check if page has lang
        if (queryFilters.length > 0 && queryFilters[1].property == "locale") {
            queryFilters[1].value.forEach((lang)=>{
                page.categories.forEach((category)=>{
                    if (category.categoryUrl) {
                        var ref;
                        const businessPath = (ref = LOCALE_LINKS[lang]) === null || ref === void 0 ? void 0 : ref.businessRoot;
                        if (!locale || lang === locale) {
                            var _categorySlug;
                            pathArray.push({
                                lang,
                                category: (_categorySlug = category.categorySlug) !== null && _categorySlug !== void 0 ? _categorySlug : "",
                                article: page.articleSlug,
                                business: businessPath !== null && businessPath !== void 0 ? businessPath : BusinessUrlPrefix.Business
                            });
                        }
                    }
                });
            });
        }
    });
    return pathArray;
}
async function createArticleStaticPaths(includeUnpublished, locale) {
    const paths = await getArticleStaticPaths(includeUnpublished, locale);
    const allPaths = paths.map((link)=>{
        return {
            params: link
        };
    });
    return {
        paths: allPaths,
        fallback: true
    };
}
async function createArticleStaticProps(param) {
    let { params , includeUnpublished  } = param;
    var ref;
    const lang = Locale.USA;
    const page = await ArticleModel.getArticle(params["article"], lang, includeUnpublished);
    const article = ArticleModel.fromBuilderContent(page);
    const relatedArticles = await ArticleModel.getRelatedArticles(article, lang);
    await awaitBuilderData(page, lang);
    const { business , category , article: articleSlug  } = params;
    var ref1;
    let pageSlug = stripLocaleFromURL((ref1 = [
        lang,
        business,
        "access",
        category,
        articleSlug
    ].join("/")) !== null && ref1 !== void 0 ? ref1 : "");
    let canonicalUrl = null;
    const host = (ref = LOCALE_LINKS[lang]) === null || ref === void 0 ? void 0 : ref.host;
    if (host) {
        canonicalUrl = "".concat(host, "/").concat(lang).concat(pageSlug);
    }
    return {
        props: {
            article: article || null,
            relatedArticles,
            canonicalUrl
        },
        revalidate: 1800
    };
}
async function createStaticPaths(includeUnpublished, locale) {
    const paths = (await getPageStaticPaths(includeUnpublished, locale)).paths;
    return {
        paths,
        fallback: true
    };
}
async function createStaticProps(param) {
    let { params , includeUnpublished  } = param;
    var ref;
    const slug = params === null || params === void 0 ? void 0 : params.slug;
    const pageSlug = Array.isArray(slug) ? slug.join("/") : slug;
    const lang = params.slug[0];
    const localifySlug = localifyLink(stripLocaleFromURL(pageSlug), Locale.Australia);
    var ref1;
    const strippedLocaleURL = stripLocaleFromURL((ref1 = slug.join("/")) !== null && ref1 !== void 0 ? ref1 : "");
    let model = BuilderModel.PAGE;
    let page = await PageModel.getPage(localifySlug, lang);
    if (!page) {
        page = await BusinessHubModel.getPage(localifySlug, lang);
        if (page) model = BuilderModel.BUSINESS_HUB;
    }
    if (page) await awaitBuilderData(page, lang);
    let canonicalUrl = null;
    const host = (ref = LOCALE_LINKS[lang]) === null || ref === void 0 ? void 0 : ref.host;
    if (host) {
        canonicalUrl = "".concat(host, "/").concat(lang).concat(strippedLocaleURL);
    }
    return {
        props: {
            page: page !== null && page !== void 0 ? page : null,
            model,
            canonicalUrl
        },
        revalidate: 3600
    };
}
async function getBuilderPreviewPage(router) {
    const locale = (0,LangHelper/* getLocaleFromRoute */._y)(router.asPath);
    const pageId = router.query["builder.overrides.".concat(BuilderModel.PAGE)];
    if (pageId) {
        const page = await Page.findById(pageId, true);
        if (page) {
            await (0,builder/* awaitBuilderData */.z$)(page, locale);
            return {
                page: page,
                model: BuilderModel.PAGE
            };
        }
    }
    const businessHubId = router.query["builder.overrides.".concat(BuilderModel.BUSINESS_HUB)];
    if (businessHubId) {
        const testVariant = router.query["builder.tests.".concat(businessHubId)];
        if (testVariant) {
            (0,cookieUtils/* setCookie */.d8)("builder.tests.".concat(businessHubId), "".concat(testVariant));
        }
        const businessHubPage = await BusinessHub/* default.findById */.Z.findById(businessHubId);
        if (businessHubPage) {
            await (0,builder/* awaitBuilderData */.z$)(businessHubPage, locale);
            return {
                page: businessHubPage,
                model: BuilderModel.BUSINESS_HUB
            };
        }
    }
}


/***/ }),

/***/ 13226:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-footer-bottom_container__6Znf4","background":"b2b-footer-bottom_background__Rr1Yy","title":"b2b-footer-bottom_title__FrMNR","button":"b2b-footer-bottom_button__lWXGQ"};

/***/ }),

/***/ 8283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"b2b-footer-contact-us_section__LFc1A","layout":"b2b-footer-contact-us_layout__MV4ad","background":"b2b-footer-contact-us_background__heHah","rounded":"b2b-footer-contact-us_rounded__VO_m2","title":"b2b-footer-contact-us_title__Uxg03","sectionForm":"b2b-footer-contact-us_sectionForm__8IrHH","sectionAfterSubmit":"b2b-footer-contact-us_sectionAfterSubmit__aKXI_"};

/***/ }),

/***/ 98416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-footer-top_container__SpO9R","background":"b2b-footer-top_background__2EohZ","imageBox":"b2b-footer-top_imageBox__FZF8b","image":"b2b-footer-top_image__N25iz","content":"b2b-footer-top_content__ChP97","left":"b2b-footer-top_left__byngE","title":"b2b-footer-top_title__Nrf6I","plus":"b2b-footer-top_plus__4y_hP","desktopBr":"b2b-footer-top_desktopBr__RQ6lw","mobileBr":"b2b-footer-top_mobileBr__RkIbo","subtitle":"b2b-footer-top_subtitle__k21ao","source":"b2b-footer-top_source__8UisE","description":"b2b-footer-top_description__QPWMt","button":"b2b-footer-top_button__8E78v","right":"b2b-footer-top_right__Stx_e","rightBox":"b2b-footer-top_rightBox__mZe3N","--light":"b2b-footer-top_--light__GZrU8"};

/***/ }),

/***/ 90801:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-footer_container__gieAr","top":"b2b-footer_top__Dkein","background":"b2b-footer_background__R5uNA"};

/***/ }),

/***/ 42770:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"b2bNewsletter":"b2b-newsletter_b2bNewsletter__g7SM_","b2bNewsletterInfo":"b2b-newsletter_b2bNewsletterInfo__aLx5i","b2bNewsletterTitle":"b2b-newsletter_b2bNewsletterTitle__pu8bY","b2bNewsletterDescription":"b2b-newsletter_b2bNewsletterDescription__6dY02","b2bNewsletterForm":"b2b-newsletter_b2bNewsletterForm__eSjJQ","b2bNewsletterFormInput":"b2b-newsletter_b2bNewsletterFormInput__lEbXv","b2bNewsletterAfterSubmit":"b2b-newsletter_b2bNewsletterAfterSubmit__tHxRa","fade-in":"b2b-newsletter_fade-in__CM0dY","b2bNewsletterFormBtnSubmit":"b2b-newsletter_b2bNewsletterFormBtnSubmit__1hSPL","b2bNewsletterInfoBackground":"b2b-newsletter_b2bNewsletterInfoBackground__mIf3H","video-spin":"b2b-newsletter_video-spin__xxaGg"};

/***/ }),

/***/ 52300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-top-navigation_container__ZMHJ7","box":"b2b-top-navigation_box__J_iyV","logo":"b2b-top-navigation_logo__BjkYh","menuItemsBg":"b2b-top-navigation_menuItemsBg__VDNy6","hamburger":"b2b-top-navigation_hamburger__7_feo","iconMenu":"b2b-top-navigation_iconMenu__QwP62","active":"b2b-top-navigation_active__K6TcA"};

/***/ }),

/***/ 59707:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"background":"business-access-primary-actions_background__U_4lw","show":"business-access-primary-actions_show__sl2ks","container":"business-access-primary-actions_container__5uuhA","mobile":"business-access-primary-actions_mobile__78voY","articleHeaderWrapper":"business-access-primary-actions_articleHeaderWrapper__rok_i","articleHeaderContainer":"business-access-primary-actions_articleHeaderContainer__XgLRH","logoAfterPayBusiness":"business-access-primary-actions_logoAfterPayBusiness__wbsiK","iconAfterPay":"business-access-primary-actions_iconAfterPay__VuX3r","businessIcon":"business-access-primary-actions_businessIcon__eU_FL","cta":"business-access-primary-actions_cta___yOju","buttonExplore":"business-access-primary-actions_buttonExplore___8gXh","iconDown":"business-access-primary-actions_iconDown__F3KCH","buttonActive":"business-access-primary-actions_buttonActive__uukDT","menuRight":"business-access-primary-actions_menuRight__1_IJj","iconSearch":"business-access-primary-actions_iconSearch__W71HW","buttonToggleDrawer":"business-access-primary-actions_buttonToggleDrawer__Paz_f","iconMenu":"business-access-primary-actions_iconMenu__fmkyR","drawerMenu":"business-access-primary-actions_drawerMenu__Wo3Re","display-none-transition":"business-access-primary-actions_display-none-transition__Kd1OC","drawerMenuButton":"business-access-primary-actions_drawerMenuButton__P8UXh","accountGroup":"business-access-primary-actions_accountGroup__6JvZL","video-spin":"business-access-primary-actions_video-spin__HqnBf"};

/***/ }),

/***/ 89713:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdownExplore":"dropdown-explore_dropdownExplore__q2QaL","toggleExploreOn":"dropdown-explore_toggleExploreOn__cmCCu","dropdownContainer":"dropdown-explore_dropdownContainer__w0Fqe","dropdownTitle":"dropdown-explore_dropdownTitle__KXrrO","latestArticles":"dropdown-explore_latestArticles__15AmV","latestArticlesContainer":"dropdown-explore_latestArticlesContainer__w_wak","latestArticlesListWrapper":"dropdown-explore_latestArticlesListWrapper__tdqDh","articleTypeTitle":"dropdown-explore_articleTypeTitle__oKymb","articleTypeName":"dropdown-explore_articleTypeName__A_ebj","exploreButtonWrapper":"dropdown-explore_exploreButtonWrapper__BikDw","exploreButtonText":"dropdown-explore_exploreButtonText__t1NpQ","moreResource":"dropdown-explore_moreResource__NikVy","moreResourceWrapper":"dropdown-explore_moreResourceWrapper__Em77K","moreResourceContainer":"dropdown-explore_moreResourceContainer__adtzp","moreResourceViewMoreIcon":"dropdown-explore_moreResourceViewMoreIcon__iPanG","moreResourceName":"dropdown-explore_moreResourceName__lpNU1","moreResourceDescription":"dropdown-explore_moreResourceDescription__iPbsb","viewAll":"dropdown-explore_viewAll__ADXWY","mobile":"dropdown-explore_mobile__W27PK"};

/***/ }),

/***/ 92990:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-menu-item_container__0QYLM","dropdownContainer":"b2b-menu-item_dropdownContainer__FTLCH","menuItem":"b2b-menu-item_menuItem__RamKN","child":"b2b-menu-item_child__E41Aq","active":"b2b-menu-item_active__u9f_A"};

/***/ }),

/***/ 17551:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-top-navigation-menu-item_container__s83t1"};

/***/ }),

/***/ 19151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-primary-actions_container__7f08I","menuItems":"business-hub-primary-actions_menuItems__OH_vd","active":"business-hub-primary-actions_active__UpUPE"};

/***/ }),

/***/ 73388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-sign-up-button_container__3B1rJ","hoverBondiMint":"business-sign-up-button_hoverBondiMint__ueqQl"};

/***/ }),

/***/ 35789:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-footnotes_container__6D90p"};

/***/ }),

/***/ 64256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page-layout":"generic_page-layout__xvmcs","business-hub-layout":"generic_business-hub-layout__1W00z","disclaimers-box":"generic_disclaimers-box__OK170","content":"generic_content__y5B5C","--no-top-padding":"generic_--no-top-padding__nEzZP","marketing-resource-center-layout":"generic_marketing-resource-center-layout__tdFo5","resource-centre-hero-container":"generic_resource-centre-hero-container__RZrEE","divider":"generic_divider__9jAmH","top-navigation":"generic_top-navigation__39atH","footer":"generic_footer__qWS0r","locale":"generic_locale__Bjp8U","copyright":"generic_copyright__rw2jt","disclaimers":"generic_disclaimers__z054P","desktop":"generic_desktop__Zctt1","mobile":"generic_mobile__tdJ6E","b2b-layout":"generic_b2b-layout__biroe","logo":"generic_logo__xGJcA"};

/***/ })

}]);